export const PREFILL_DATA_SAVED = 'PREFILL_DATA_SAVED';

export const prefillDataSaved = payload => dispatch =>
  dispatch({
    type: PREFILL_DATA_SAVED,
    payload,
  });
